var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('selfcheck-calling-modal',{attrs:{"visible":_vm.modalShow,"invert":_vm.isCheckPage,"disabled":_vm.isCanceling},on:{"cancel":_vm.cancel}},[(_vm.isCheckPage)?_c('so-quit-button-container'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }